"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState, FC } from "react";
import { Swiper as SwiperType } from "swiper";
import HorizontalProductCard from "../cards/horizontalProductCard/HorizontalProductCard";
import SwiperButton from "../buttons/SwiperButton";
import ViewAllButton from "../buttons/ViewAllButton";
import { SearchProduct } from "@/app/lib/features/search/search.types";

interface SearchSpecialProductsSwiperProps {
  products: SearchProduct[];
  onClose?: () => void;
}

const SearchSpecialProductsSwiper: FC<SearchSpecialProductsSwiperProps> = ({
  products,
  onClose,
}) => {
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(true);

  const updateGradients = (swiper: SwiperType): void => {
    setShowLeftGradient(!swiper.isBeginning);
    setShowRightGradient(!swiper.isEnd);
  };

  return (
    <Swiper
      className="relative"
      spaceBetween={8}
      slidesPerView={1.4}
      onSwiper={updateGradients}
      onSlideChange={updateGradients}
      watchSlidesProgress={false}
      updateOnWindowResize={false}
      breakpoints={{
        480: { slidesPerView: 2.4, spaceBetween: 10 },
        640: { slidesPerView: 2.6, spaceBetween: 12 },
        1024: { slidesPerView: 2.4, spaceBetween: 12 },
      }}
    >
      {products.map((product) => (
        <SwiperSlide key={product.id} className="h-auto! flex!">
          <HorizontalProductCard product={product} onClose={onClose} />
        </SwiperSlide>
      ))}
      <SwiperSlide className="h-auto! flex!">
        <ViewAllButton slug="/special-products" onClick={onClose} />
      </SwiperSlide>
      <div className="absolute z-50 top-1/2 -translate-y-1/2 left-0 w-full items-center justify-between px-3 pointer-events-none hidden xl:flex">
        <SwiperButton position="left" />
        <SwiperButton position="right" />
      </div>
      <div
        className={`absolute top-0 left-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-r from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showLeftGradient ? "opacity-100" : "opacity-0"
        }`}
      />
      <div
        className={`absolute top-0 right-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-l from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showRightGradient ? "opacity-100" : "opacity-0"
        }`}
      />
    </Swiper>
  );
};

export default SearchSpecialProductsSwiper;
